import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './App.css';
import './styles/custom-tabs.css';
import { setSEO } from './util/seo';

import MainLayout from './components/Layout';
;

// Set moment.js locale to Chinese
moment.locale('zh-cn');

const MemberCard = lazy(() => import('./components/MemberCard'));
const AdmissionCard = lazy(() => import('./components/AdmissionCard'));
const Login = lazy(() => import('./pages/login/index'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const PlannerForm = lazy(() => import('./components/PlannerForm'));
const OfflineArchive = lazy(() => import('./components/OfflineArchive'));
const TeamManagement = lazy(() => import('./components/TeamManagement'));
const BasicInfo = lazy(() => import('./components/BasicInfo'));
const WalletManagement = lazy(() => import('./components/WalletManagement'));
const CouponManagement = lazy(() => import('./components/CouponManagement'));
const InviteCodeManagement = lazy(() => import('./components/InviteCodeManagement'));
const RoleSelect = lazy(() => import('./pages/RoleSelect'));
const MemberPoints = lazy(() => import('./components/MemberPoints'));
const CollegeAdmissionData = lazy(() => import('./pages/CollegeAdmissionData'));
const AI = lazy(() => import('./pages/AI'));
const UserAgreement = lazy(() => import('./pages/UserAgreement'));

// const Toolbox = lazy(() => import('./pages/Toolbox'));
// const DataManagement = lazy(() => import('./pages/DataManagement'));
// const BasicData = lazy(() => import('./pages/DataManagement/BasicData'));
// const RecordData = lazy(() => import('./pages/DataManagement/RecordData'));
// const MatchData = lazy(() => import('./pages/DataManagement/MatchData'));
// const BatchData = lazy(() => import('./pages/DataManagement/BatchData'));
// const OnlineOrders = lazy(() => import('./components/OnlineOrders'));
// const ServiceList = lazy(() => import('./components/ServiceList'));
// const ConsumerList = lazy(() => import('./components/ConsumerList'));
// const AdmissionPlan = lazy(() => import('./pages/AdmissionPlan'));
// const ScoreDistribution = lazy(() => import('./pages/ScoreDistribution'));
// const BatchScores = lazy(() => import('./pages/BatchScores'));
// const RankConversion = lazy(() => import('./pages/RankConversion'));
// const AdmissionData = lazy(() => import('./pages/AdmissionData'));
// const MajorData = lazy(() => import('./pages/MajorData'));


const AppLayout = () => {
  return (
    <MainLayout>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="planner" element={<PlannerForm />} />
        <Route path="offline" element={<OfflineArchive />} />
        {/* <Route path="online/orders" element={<OnlineOrders />} />
        <Route path="online/services" element={<ServiceList />} />
        <Route path="online/consumer" element={<ConsumerList />} />
        <Route path="online" element={<Navigate to="online/orders" replace />} /> */}
        <Route path="team" element={<TeamManagement />} />
        <Route path="basic" element={<BasicInfo />} />
        <Route path="wallet" element={<WalletManagement />} />
        <Route path="card/member" element={<MemberCard />} />
        <Route path="card/admission" element={<AdmissionCard />} />
        <Route path="points" element={<MemberPoints />} />
        <Route path="coupon" element={<CouponManagement />} />
        <Route path="invite-code" element={<InviteCodeManagement />} />
        {/* <Route path="toolbox" element={<Toolbox />} /> */}
        <Route path="ai" element={<AI />} />
        {/* <Route path="data-management" element={<DataManagement />}>
          <Route path="basic" element={<BasicData />} />
          <Route path="record" element={<RecordData />} />
          <Route path="match" element={<MatchData />} />
          <Route path="batch" element={<BatchData />} />
          <Route path="" element={<Navigate to="basic" replace />} />
        </Route> */}
        {/* <Route path="planner/early" element={<AdmissionPlan />} />
        <Route path="planner/regular" element={<AdmissionPlan />} />
        <Route path="planner/art" element={<AdmissionPlan />} />
        <Route path="planner/sports" element={<AdmissionPlan />} />
        <Route path="admission/school-scores" element={<AdmissionData />} />
        <Route path="admission/major-scores" element={<AdmissionData />} /> */}
        {/* <Route path="info/school" element={<MajorData />} />
        <Route path="info/major" element={<MajorData />} />
        <Route path="info/job" element={<MajorData />} />
        <Route path="info/subject" element={<MajorData />} /> */}
        {/* <Route path="other/rank-conversion" element={<RankConversion />} />
        <Route path="other/score-distribution" element={<ScoreDistribution />} />
        <Route path="other/batch-scores" element={<BatchScores />} /> */}
        <Route path="college-admission" element={<CollegeAdmissionData />} />

        <Route path="" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </MainLayout>
  );
};

function App() {
  // Set global SEO
  useEffect(() => {
    setSEO('default');
  }, []);

  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Suspense fallback={<div className='py-2 px-2'>加载中...</div>}>
          <Routes>
            <Route
              path="/role"
              element={<RoleSelect />} />
            <Route
              path="/user-agreement"
              element={<UserAgreement />} />
            <Route path="/*" element={<AppLayout />} />
          </Routes>
        </Suspense>

      </Router>
    </ConfigProvider>
  );
}

export default App;